import React from 'react';
import { Box, Typography } from '@mui/material';
import ResponsiveDialogue from '../../ResponsiveDialogue/ResponsiveDialogue';
import RoundedButton from '../../RoundedButton/RoundedButton';

interface DuplicateEmailAddressModalProps {
	open: boolean;
	onClose: () => void;
}

export const duplicateEmailAddressError = 'EMAIL_ADDRESS_ALREADY_IN_USE';
const duplicateEmailAddressTitle = 'Error: Duplicate Email Address';
const duplicateEmailAddressMessage =
	'The email address you have entered is already in use. ' +
	'Please use a different email address.';

const DuplicateEmailAddressModal: React.FC<DuplicateEmailAddressModalProps> = ({ open, onClose }) => {
	return (
		<ResponsiveDialogue
			data-testid="duplicate-email-address-dialogue"
			open={open}
			onClose={onClose}
			title={duplicateEmailAddressTitle}

		>
			<Box sx={{
				pt: 2
			}}>
				<Typography variant="body1" fontWeight="bold">{duplicateEmailAddressMessage}</Typography>
			</Box>
			<Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }}>
				<Box>
					<RoundedButton
						variantStyle="dark"
						variant="contained"
						data-testid="close-duplicate-email-address-error-button"
						onClick={() => onClose()}
					>
						Close
					</RoundedButton>
				</Box>
			</Box>
		</ResponsiveDialogue>
	);
};

export default DuplicateEmailAddressModal;
